import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { useId } from "react";
import { Tooltip } from "react-tooltip";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
export default function DropForgeStatusPill(t0) {
  const $ = _c(21);
  const {
    className,
    label,
    showLoader: t1,
    tooltipText
  } = t0;
  const showLoader = t1 === undefined ? false : t1;
  const tooltipId = useId();
  let t2;
  if ($[0] !== tooltipId || $[1] !== tooltipText) {
    t2 = tooltipText ? {
      "data-tooltip-id": tooltipId,
      "data-tooltip-content": tooltipText
    } : {};
    $[0] = tooltipId;
    $[1] = tooltipText;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = tooltipText && "tw-cursor-help";
  let t4;
  if ($[3] !== className || $[4] !== t3) {
    t4 = clsx("tw-inline-flex tw-max-w-full tw-items-center tw-gap-2 tw-rounded-full tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-leading-tight tw-ring-1 tw-ring-inset", t3, className);
    $[3] = className;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== showLoader) {
    t5 = showLoader ? <CircleLoader size={CircleLoaderSize.SMALL} /> : <span className="tw-inline-block tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-current" />;
    $[6] = showLoader;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== label) {
    t6 = <span>{label}</span>;
    $[8] = label;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <span {...t2} className={t4}>{t5}{t6}</span>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== tooltipId || $[16] !== tooltipText) {
    t8 = tooltipText && <Tooltip id={tooltipId} place="top-start" border="1px solid rgba(255, 255, 255, 0.15)" opacity={1} style={{
      backgroundColor: "#26272B",
      color: "#F4F4F5",
      padding: "8px 10px",
      maxWidth: "260px",
      fontSize: "12px",
      lineHeight: "1.35",
      borderRadius: "8px"
    }} />;
    $[15] = tooltipId;
    $[16] = tooltipText;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}